import React from "react";
import { Navigate } from "react-router-dom";
import Dashboard from "../pages/dashboard/dashboard.js";
import Users from "../pages/pages/users/users.js";
import UsersDetails from "../pages/pages/users/usersDetails.js";
import Customer from "../pages/pages/customers/customers.js";
import CustomerDetails from "../pages/pages/customers/customerDetails.js";
import Vehicles from "../pages/pages/vehicles/vehicles.js";
import VehiclesDetails from "../pages/pages/vehicles/vehiclesDetails.js";
import Sellers from "../pages/pages/sellers/sellers.js";
import SellersDetails from "../pages/pages/sellers/sellersDetails.js";
import Branches from "../pages/pages/branches/branches.js";
import BranchesDetails from "../pages/pages/branches/branchesDetails.js";
import Appointments from "../pages/pages/appointments/appointments.js";
import AppointmentsDetails from "../pages/pages/appointments/appointmentsDetails.js";
import PagesError from "../pages/pages/error.js";
import LoginPage from "../auth/pages/LoginPage.jsx";
import ProtectedRoute from "../auth/components/ProtectedRoute.js";
import Settings from "../pages/pages/settings/settings.js";
import App from "../app.jsx";

const AppRoute = [
	{
		path: "",
		element: <App />,
		children: [
			{ path: "login", element: <LoginPage /> },
			{ path: "/", element: <Navigate to="/login" /> },
			{
				path: "/*",
				element: <ProtectedRoute />,
				children: [
					{
						path: "dashboard",
						element: <Dashboard />,
					},
					{
						path: "users",
						element: <Users />,
					},
					{
						path: "usersDetails",
						element: <UsersDetails />,
					},
					{
						path: "customers",
						element: <Customer />,
					},
					{
						path: "customersDetails",
						element: <CustomerDetails />,
					},
					{
						path: "vehicles",
						element: <Vehicles />,
					},
					{
						path: "vehiclesDetails",
						element: <VehiclesDetails />,
					},
					{
						path: "sellers",
						element: <Sellers />,
					},
					{
						path: "sellersDetails",
						element: <SellersDetails />,
					},
					{
						path: "branches",
						element: <Branches />,
					},
					{
						path: "branchesDetails",
						element: <BranchesDetails />,
					},
					{
						path: "appointments",
						element: <Appointments />,
					},
					{
						path: "appointmentsDetails",
						element: <AppointmentsDetails />,
					},
					{
						path: "settings",
						element: <Settings />,
					},
					{ path: "*", element: <PagesError /> },
				],
			},
		],
	},
];

export default AppRoute;
